import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import styles from '@components/StoreCard/StoreCard.styles';
import Button from '@components/Button/Button';
import Heading from '@components/Heading/Heading';
import Icon from '@components/icons/Icon';
import { IPointOfPresence, IGoogleMapLocation } from '@features/checkout/typescript';
import sanitizeHtml from '@utils/sanitizeHtml';
import { prepareShowroomUrl, getPimInternalId, onClickNavigate, getUserGeolocation, navigationPossible, getShowroomType, getOpeningHours } from '@utils/showroom';
type TPropsType = {
  store: IPointOfPresence;
  userGeolocation: IGoogleMapLocation | undefined;
  onClick?: () => void;
  onAuxClick?: () => void;
};
const StoreCard = ({
  store,
  userGeolocation,
  onClick,
  onAuxClick
}: TPropsType) => {
  const {
    t
  } = useTranslation('common');
  const openingHours = store?.openingHours?.description ? getOpeningHours(store, t, true).replaceAll('\n', '<br/>') : '';
  const hendleNavigate = async () => {
    if (userGeolocation && userGeolocation?.lat && userGeolocation?.lng) {
      void onClickNavigate(store.location, userGeolocation && userGeolocation?.lat && userGeolocation?.lng ? userGeolocation : null);
    } else {
      const userGeolocationFromBrowser = await getUserGeolocation();
      void onClickNavigate(store.location, userGeolocationFromBrowser && userGeolocationFromBrowser?.lat && userGeolocationFromBrowser?.lng ? userGeolocationFromBrowser : null);
    }
    if (onClick) {
      onClick();
    }
  };
  return <div sx={styles.storeContainer}>
      <div sx={styles.storeHeadingContainer}>
        {store?.address?.city && <span sx={styles.spanText}>{store.address.city}</span>}
        <Heading h={4} headingType={3} mobile>
          {getShowroomType(store?.group?.code, t)}
        </Heading>
      </div>
      <div sx={styles.storeAddressContainer}>
        <div sx={styles.address}>
          {store?.address && (store.address.mallName || store.address.locationHint) && <span sx={styles.textRow}>
              {store.address.mallName && `${store.address.mallName}, `}
              {store.address.locationHint && store.address.locationHint}
            </span>}
          {store?.address?.street && store?.address?.city && <>
              <span sx={styles.textRow}>{store.address.street}</span>
              <span sx={styles.textRow}>
                {store.address.postalCode}, {store.address.city}
              </span>
            </>}
          {store?.contact?.emails && store.contact.emails?.length > 0 && <a href={`mailto:${store.contact.emails[0]}`}>{store.contact.emails[0]}</a>}
          {store?.contact?.phones && store.contact.phones?.length > 0 && <span sx={styles.textRowPhone}>
              {t('phone')} {store.contact.phones[0]}
            </span>}
        </div>
        {openingHours && <div sx={styles.hours} dangerouslySetInnerHTML={sanitizeHtml(openingHours)} />}
      </div>
      <div sx={styles.about}>
        {store?.group?.code && store?.name && store?.ids && typeof store?.ids['INTERNAL-PIM-ID'] === 'string' && <Link href={prepareShowroomUrl(store?.group?.code, store?.name, getPimInternalId(store), t)} onClick={onClick} onAuxClick={onAuxClick}>
            <Button variantColor="dark" size="small">
              {t('aboutStore')}
            </Button>
          </Link>}
        {navigationPossible(store?.location) && <Button variant="link" size="small" letterCase="lowercase" onClick={hendleNavigate} addSx={styles.directionsLink}>
            <Icon icon="Place1" size="24px" /> <span sx={styles.directionsLinkText}>{t('checkRoute')}</span>
          </Button>}
      </div>
    </div>;
};
export default StoreCard;